import { SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";
class AssetService {
  DoGetAssetTemplateCodeByAssetTemplateIdList(assetTemplateIdList: Array<number>) {
    const _input = {
      assetTemplateIdList: assetTemplateIdList,
    };
    return service.peakExportAPI
      .post("/api/Asset/GetAssetTemplateCodeByAssetTemplateIdList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new AssetService();
